module.exports = __webpack_public_path__ + "img/RX-RAD-CONVENCIONAL-Salas-7-zoom.3c746fe3.png";